/* ============================================================
   Brockett Built — theme.js
   Global behaviors: mega menu, mobile nav, accordions, scroll
   ============================================================ */

(function () {
  'use strict';

  // ---- Money formatter (uses shop's money format from window.theme) ----
  window.formatMoney = function (cents) {
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  };

  // ---- Mega menu (desktop hover) ----
  document.querySelectorAll('.nav-link.has-mega').forEach(link => {
    const target = link.dataset.mega;
    const panel = document.querySelector('[data-mega-panel="' + target + '"]');
    if (!panel) return;
    let leaveTimer;
    const openMega = () => { clearTimeout(leaveTimer); panel.setAttribute('data-open', 'true'); };
    const closeMega = () => { leaveTimer = setTimeout(() => panel.setAttribute('data-open', 'false'), 150); };
    link.addEventListener('mouseenter', openMega);
    link.addEventListener('mouseleave', closeMega);
    panel.addEventListener('mouseenter', openMega);
    panel.addEventListener('mouseleave', closeMega);
  });

  // ---- Mobile nav drawer ----
  document.querySelectorAll('[data-toggle="mobile-nav"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const drawer = document.getElementById('mobile-nav');
      if (!drawer) return;
      const isOpen = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', !isOpen);
      const overlay = document.getElementById('drawer-overlay');
      if (overlay) overlay.setAttribute('data-open', !isOpen);
      document.body.style.overflow = !isOpen ? 'hidden' : '';
    });
  });

  // ---- Accordions ----
  document.addEventListener('click', (e) => {
    const head = e.target.closest('[data-accordion-toggle]');
    if (!head) return;
    const acc = head.closest('.accordion');
    if (!acc) return;
    acc.setAttribute('data-open', acc.getAttribute('data-open') === 'true' ? 'false' : 'true');
  });

  // ---- Drawer overlay tap close all drawers ----
  const overlay = document.getElementById('drawer-overlay');
  if (overlay) {
    overlay.addEventListener('click', () => {
      document.querySelectorAll('[data-open="true"]').forEach(el => {
        if (el !== overlay) el.setAttribute('data-open', 'false');
      });
      overlay.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    });
  }

  // ---- Escape close all drawers ----
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelectorAll('.cart-drawer[data-open="true"], .search-drawer[data-open="true"], .mobile-nav[data-open="true"], .mega-menu[data-open="true"]');
    if (open.length === 0) return;
    open.forEach(el => el.setAttribute('data-open', 'false'));
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  });

  // ---- Vehicle chip listener - filter collection grid if vehicle is set ----
  document.addEventListener('vehicle:change', (e) => {
    const v = e.detail.vehicle;
    // On collection pages with vehicle filter facet, redirect would happen here
    // For now we just keep the chip state synced
    if (v) {
      // vehicle selection state will be wired to collection facets here
    }
  });

  // ---- Quick add (collection cards) ----
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    const hasVariants = btn.dataset.hasVariants === 'true';
    if (hasVariants) {
      // Navigate to PDP - variant selection required
      const card = btn.closest('.card');
      if (card && card.href) window.location = card.href;
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const original = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add failed');
      btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:update'));
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
    } catch (err) {
      btn.textContent = 'Error';
      console.error(err);
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  });

  // ---- Search drawer open/close ----
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-search"]')) {
      e.preventDefault();
      const d = document.getElementById('search-drawer');
      if (d) {
        d.setAttribute('data-open', 'true');
        const overlay = document.getElementById('drawer-overlay');
        if (overlay) overlay.setAttribute('data-open', 'true');
        const input = d.querySelector('[data-predictive-input]');
        if (input) setTimeout(() => input.focus(), 100);
      }
    }
    if (e.target.closest('[data-action="close-search"]')) {
      const d = document.getElementById('search-drawer');
      if (d) d.setAttribute('data-open', 'false');
      const overlay = document.getElementById('drawer-overlay');
      if (overlay) overlay.setAttribute('data-open', 'false');
    }
  });

  // ============================================================
  //   Product form (PDP) - variant selection, fitment, sticky ATC
  // ============================================================
  const form = document.querySelector('[data-product-form]');
  if (form) initProductForm(form);

  function initProductForm(form) {
    const jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);

    const variantInput = form.querySelector('[data-variant-id]');
    const atcBtn = form.querySelector('[data-atc-btn]');
    const priceEl = document.querySelector('[data-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyBtn = document.querySelector('[data-sticky-atc-btn]');

    // Currently selected option values, ordered by product.options
    const selected = [];
    product.options.forEach((_, i) => {
      const initial = product.variants[0].options[i];
      const checkedPill = form.querySelector(
        `.option-pills[data-option-name] .option-pill[aria-checked="true"][data-option-position="${i}"]`
      );
      selected[i] = checkedPill ? checkedPill.dataset.optionValue : initial;
    });

    function findVariant() {
      return product.variants.find(v => v.options.every((val, i) => val === selected[i]));
    }

    function applyVariant() {
      const v = findVariant();
      if (!v) {
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = window.theme.strings.unavailable || 'Unavailable';
        }
        return;
      }
      variantInput.value = v.id;
      if (priceEl) priceEl.innerHTML = window.formatMoney(v.price);
      if (stickyPrice) stickyPrice.innerHTML = window.formatMoney(v.price);

      const fitmentSelected = isFitmentSelected();
      const canBuy = v.available && fitmentSelected;
      if (atcBtn) {
        atcBtn.disabled = !canBuy;
        if (!v.available) atcBtn.textContent = window.theme.strings.soldOut;
        else if (!fitmentSelected) atcBtn.textContent = window.theme.strings.selectFitment;
        else atcBtn.textContent = `${window.theme.strings.addToCart} - ${window.formatMoney(v.price)}`;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !canBuy;
        stickyBtn.textContent = canBuy ? 'Add' : (v.available ? 'Select' : 'Sold out');
      }

      // Sync URL ?variant=
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      } catch (e) {}

      updateFbtTotal();
    }

    function isFitmentSelected() {
      // Required if a "Fitment" option exists and there's no selection (Default Title doesn't count)
      const fitmentIdx = product.options.findIndex(o => /fitment/i.test(o));
      if (fitmentIdx === -1) return true;
      return !!selected[fitmentIdx];
    }

    function updateFbtTotal() {
      const totalEl = document.querySelector('[data-fbt-total]');
      if (!totalEl) return;
      const v = findVariant();
      let total = v ? v.price : 0;
      document.querySelectorAll('[data-fbt-check]:checked').forEach(cb => {
        total += parseInt(cb.dataset.price, 10) || 0;
      });
      totalEl.innerHTML = window.formatMoney(total);
    }

    // Option pill click
    form.querySelectorAll('.option-pills').forEach(group => {
      group.querySelectorAll('.option-pill').forEach(pill => {
        pill.addEventListener('click', () => {
          group.querySelectorAll('.option-pill').forEach(p => p.setAttribute('aria-checked', 'false'));
          pill.setAttribute('aria-checked', 'true');
          const pos = parseInt(pill.dataset.optionPosition, 10);
          selected[pos] = pill.dataset.optionValue;
          const labelSelected = form.querySelector(`[data-selected-option-${pos}]`);
          if (labelSelected) labelSelected.textContent = pill.dataset.optionValue;
          applyVariant();
        });
      });
    });

    // Qty stepper
    form.querySelectorAll('[data-qty-step]').forEach(b => {
      b.addEventListener('click', () => {
        const input = form.querySelector('[data-qty-input]');
        if (!input) return;
        const delta = parseInt(b.dataset.qtyStep, 10);
        input.value = Math.max(1, parseInt(input.value, 10) + delta);
      });
    });

    // Fitment confirm
    const fitmentSelect = document.querySelector('[data-fitment-select]');
    const fitmentBox = document.querySelector('[data-fitment-confirm]');
    const fitmentResult = document.querySelector('[data-fitment-result]');
    if (fitmentSelect) {
      fitmentSelect.addEventListener('change', () => {
        const val = fitmentSelect.value;
        if (!val) { fitmentBox.setAttribute('data-state', 'unset'); fitmentResult.textContent = ''; return; }
        if (val === 'other') {
          fitmentBox.setAttribute('data-state', 'unknown');
          fitmentResult.innerHTML = 'Not sure if it fits? <a href="/pages/contact" style="text-decoration:underline;">Contact us</a> with your VIN.';
          return;
        }
        fitmentBox.setAttribute('data-state', 'confirmed');
        fitmentResult.innerHTML = `Confirmed fits your ${val}.`;
      });
    }

    // FBT checkbox totals
    document.querySelectorAll('[data-fbt-check]').forEach(cb => {
      cb.addEventListener('change', updateFbtTotal);
    });

    // Form submit AJAX add
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);

      // Also include any checked FBT items
      const fbtItems = [...document.querySelectorAll('[data-fbt-check]:checked')]
        .map(cb => ({ id: cb.dataset.variantId, quantity: 1 }));

      const mainItem = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      const items = [mainItem, ...fbtItems];

      atcBtn.disabled = true;
      const original = atcBtn.textContent;
      atcBtn.textContent = 'Adding...';

      try {
        const res = await fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('Add failed');
        atcBtn.textContent = window.theme.strings.added;
        atcBtn.style.background = 'var(--success)';
        atcBtn.style.borderColor = 'var(--success)';
        document.dispatchEvent(new CustomEvent('cart:update'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(() => {
          atcBtn.textContent = original;
          atcBtn.style.background = '';
          atcBtn.style.borderColor = '';
          applyVariant();
        }, 2000);
      } catch (err) {
        atcBtn.textContent = 'Error';
        setTimeout(() => { atcBtn.textContent = original; applyVariant(); }, 2000);
      }
    });

    // Sticky ATC mirrors the form submit
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => form.dispatchEvent(new Event('submit', { cancelable: true })));
    }

    // Sticky ATC visibility on scroll
    const gallery = document.querySelector('.pdp__media-col');
    const stickyEl = document.getElementById('sticky-atc');
    if (gallery && stickyEl) {
      window.addEventListener('scroll', () => {
        const rect = gallery.getBoundingClientRect();
        const past = rect.bottom < 200;
        stickyEl.setAttribute('data-visible', past && window.innerWidth < 1024 ? 'true' : 'false');
      }, { passive: true });
    }

    applyVariant();
  }
})();
